export const environment = {
  appVersion: require('../../package.json').version,
  production: true,

  // these values will change based on the environment you are deploying to
   root_API_URL: 'https://www.keepitgreen4u.com/rootapi/',
};
